export default __webpack_public_path__ + "418450168a92c7559bc8b2747856fdb0.woff";